<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-warning">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <stats-card
            title="Total traffic"
            type="gradient-red"
            sub-title="350,897"
            icon="ni ni-active-40"
            class="mb-4"
          >
            <template slot="footer">
              <span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="Total traffic"
            type="gradient-orange"
            sub-title="2,356"
            icon="ni ni-chart-pie-35"
            class="mb-4"
          >
            <template slot="footer">
              <span class="text-success mr-2">12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="Sales"
            type="gradient-green"
            sub-title="924"
            icon="ni ni-money-coins"
            class="mb-4"
          >
            <template slot="footer">
              <span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="Performance"
            type="gradient-info"
            sub-title="49,65%"
            icon="ni ni-chart-bar-32"
            class="mb-4"
          >
            <template slot="footer">
              <span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-container fluid>
              <b-row class="my-1">
                <b-col sm="3">
                  <label :for="`type-${type}`"
                    >No. telefon / No. Bimbit<code>{{ type }}</code
                    >:</label
                  >
                </b-col>
                <b-col sm="5">
                  <b-form-input
                    :id="`type-${type}`"
                    :type="type"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="3">
                  <label :for="`type-${type}`"
                    >No. Kad Pengenalan<code>{{ type }}</code
                    >:</label
                  >
                </b-col>
                <b-col sm="5">
                  <b-form-input
                    :id="`type-${type}`"
                    :type="type"
                  ></b-form-input>
                </b-col>
              </b-row>

              <div>
                <b-col sm="3">
                  <b-button>Cari</b-button>
                  <b-button>Set Semula</b-button>
                </b-col>
              </div>
            </b-container>

            <!-- <div>
    <div class="mt-2">No. telefon / No. Bimbit : {{ text }}
    <b-form-input v-model="text" placeholder="Enter your name"></b-form-input></div>

  </div>
  <div>
    <div class="mt-2">No. Kad Pengenalan  : {{ text }}</div>
    <b-form-input v-model="text" placeholder="Enter your name"></b-form-input>
  </div> -->
          </card>
        </b-col>
      </b-row>
    </b-container>
    <b-row class="my-1">
      <b-col sm="3">
        <label for="input-none">No State:</label>
      </b-col>
      <b-col sm="9">
        <b-form-input
          id="input-none"
          :state="null"
          placeholder="No validation"
        ></b-form-input>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import BaseHeader from "@/components/BaseHeader";

Vue.use(VueClipboard);
export default {
  name: "icons",
  components: {
    BaseHeader,
  },
  methods: {
    onCopy() {
      this.$notify({
        type: "info",
        message: "Copied to clipboard",
      });
    },
  },
};
</script>
<script>
export default {
  data() {
    return {
      types: ["tel", "number"],
    };
  },
};
</script>
<style></style>
